import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductRefundDocument.Order.IRequest;
type Response = Api.Core.ProductRefundDocument.Order.IResponse;
type Headers = Api.Core.ProductRefundDocument.Order.IHeaders;
const url = '/api/ProductManagement/ProductRefundDocument/DocumentOrder';
export default async function productRefundDocumentOrderApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
